const options = Array.from({ length: 225 }, (_, i) => ({ option: (1800 + i).toString() }));
    const option1 = Array.from({ length: 51 }, (_, i) => {
                      const startYear = 2000 + i;
                      const endYear = startYear + 1;
                      return { option: `${startYear}-${endYear.toString().slice(-2)}` };
                    });

export const Additionaldocuments = [
  {
    type: 'dropdown', 
    question_no: 'choose_option', 
    question: 'Certification Framework', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Comprehensive Capacity Building and Due Diligence Framework(qualify for Platinum/Gold/Silver/Bronze Seal based on your certification score)"},{"option": "Basic KYC (Know Your Changemaker) Framework (you may qualify for Bronze Seal based on your certification score card)"}]
    , 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_fcra', 
    question: 'FCRA - Change in FCRA status', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve1', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_fcra', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_pan', 
    question: 'Income Tax - Change in PAN', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve2', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_pan', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'tax_exemption', 
    question: 'Income Tax - Change in tax exemption registration', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve3', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'tax_exemption', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_registered_name', 
    question: 'Legal - Change of Registered Name', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve5', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_registered_name', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_deed', 
    question: 'Legal - Change in MoA/ Trust Deed', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve7', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_deed', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_aoa', 
    question: 'Legal - Change in AoA/ Bye Laws', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve8', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_aoa', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_of_governing_body', 
    question: 'Legal - Change of Governing Body Members', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve9', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_of_governing_body', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'statutory_authorities', 
    question: 'Legal - Change in status of ongoing/ new litigations/ inquiries', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve12', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'statutory_authorities', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'Registeration_changes_employment', 
    question: 'Legal - Change in any other registration with other statutory authorities required for employment of people?', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve23', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'Registeration_changes_employment', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'specify_activity', 
    question: 'Legal - Change in any other registration with other statutory authorities required for carrying out specific activities/ programmes of the organisation (such as Education, Health Department, Micro Finance)', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approved13', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'specify_activity', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'office_operation_activity', 
    question: 'Legal - Change in any other registration with other statutory authorities required for establishment of office/ operations (such as running a shelter home/ hospital/ manufacturing unit)', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve14', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'office_operation_activity', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_law', 
    question: 'Legal - Change in any laws that now become applicable for your organisation or now become not applicable', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve15', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_law', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_correspondence', 
    question: 'Operations - Change in Correspondence Office/ Address', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve16', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_correspondence', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_chief_functionary', 
    question: 'Operations - Change of Chief Functionary and Key Management Staff', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve17', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_chief_functionary', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_in_key_programmes', 
    question: 'Operations - Change in Key Programmes', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve18', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_in_key_programmes', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_geographic_area', 
    question: 'Operations - Change in Main Geographic Area of Operations', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve19', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_geographic_area', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'changes_impact_assessment', 
    question: 'Operations - Changes in impact assessment indicators, methodology', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve20', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'changes_impact_assessment', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_books_of_accounts', 
    question: 'Operations - Change in Location of Books of Accounts', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve21', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_books_of_accounts', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'change_of_auditor', 
    question: 'Operations - Change of Auditor', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Yes"} , {"option":"No"}], 
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'intimate_approve22', 
    question: 'Intimated/Approved', 
    description: '', 
    depend_question: 'change_of_auditor', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Intimated"},{"option": "Approved"}], 
    mandatory: 1,
  },



  {
    type: 'text', 
    question_no: 'other_event', 
    question: 'Operations - Any other event/ change that impacts the functioning of the organisation', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: [], 
    mandatory: 0,
  },
  {
    type: 'dropdown', 
    question_no: 'choose_one_option', 
    question: 'Choose any one option to meet the cost of certification (Non refundable)', 
    description: 'PLEASE DO NOT DEPOSIT CASH. PLEASE DO NOT MAKE ANY TRANSFER OF FOREIGN FUNDS FROM YOUR ORGANISATION UNDER ANY CIRCUMSTANCE', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "We are depositing a cheque as the contribution from our donor"},{"option": "Our donor will contribute directly through a fund transfer"},{"option": "We are making a cheque deposit/ NEFT from our organisation as our contribution"}], 
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'name_person_filling_form', 
    question: 'Name of the person filling the form', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: [], 
    mandatory: 1,
  },

  {
    type: 'text', 
    question_no: 'legal_name_organisation', 
    question: 'Legal name of your Organization ', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: [], 
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'organisation_it_pan', 
    question: 'Organization IT PAN ', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes',
    validation:'pan', 
    options: [],
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'contact_person_name', 
    question: 'Contact Person Name ', 
    description: '', 
    depend_question: 'field3',
    condition: 'equals', 
    value: 'yes', 
    validation:'text',
    options: [],
    mandatory: 1,
  },
  {
    type: 'email', 
    question_no: 'contact_persons__email_id', 
    question: 'Contact Person’s Email ID', 
    description: '', 
    depend_question: 'field4',
    condition: 'equals', 
    value: 'yes', 
    validation:'email',
    options: [],
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'contact_persons_number', 
    question: 'Contact Person’s Contact Number ', 
    description: 'We prefer mobile number to filled here', 
    depend_question: 'field5',
    condition: 'equals', 
    value: 'yes', 
    validation:'number',
    options: [],
    mandatory: 1,
  },

  {
    type: 'text', 
    question_no: 'head_of_org_name', 
    question: "Head of Organisation's Name", 
    description: '', 
    depend_question: 'field0', 
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: [], 
    mandatory: 1,
    disable:true
  },
  {
    type: 'email', 
    question_no: 'head_of_org_email_id', 
    question: "Head of Organisation’s email id", 
    description: '', 
    depend_question: 'field1',
    condition: 'equals', 
    value: 'yes', 
    validation:'email', 
    options: [],
    mandatory: 1,
    disable:true
  },
  {
    type: 'text', 
    question_no: 'contact_person_finance', 
    question: 'Contact Person from Finance/Accounts Teams Name', 
    description: '', 
    depend_question: 'field2',
    condition: 'equals', 
    value: 'yes',
    validation:'text', 
    options: [],
    mandatory: 1,
  },
  {
    type: 'email', 
    question_no: 'email_contact_person', 
    question: 'Email ID of Contact Person’s from Finance/Accounts Team', 
    description: '', 
    depend_question: 'field3',
    condition: 'equals', 
    value: 'yes', 
    validation:'email',
    options: [],
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'contact_number_person', 
    question: 'Contact Number of Contact Person from Finance/Accounts Team', 
    description: '', 
    depend_question: 'field4',
    condition: 'equals', 
    value: 'yes', 
    validation:'number',
    options: [],
    mandatory: 1,
  },
  {
    type: 'dropdown', 
    question_no: 'know_about_gsi', 
    question: 'How did you come to know about GuideStar India certification?', 
    description: '', 
    depend_question: '', 
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown', 
    options: [{"option": "Email from GuideStar India","value": null,"explanation": null},{"option": "GuideStar India workshop","value": null,"explanation": null},{"option": "Other","value": null,"explanation": null}]
    , 
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'other1', 
    question: 'Other (Please Specify)', 
    description: '', 
    depend_question: 'know_about_gsi',
    condition: 'equals', 
    value: 'yes', 
    validation:'text', 
    options: [],
    mandatory: 0,
  },
  {
    type: 'dropdown', 
    question_no: 'financial_year', 
    question: 'Financial Year', 
    description: '', 
    depend_question: 'field2',
    condition: 'equals', 
    value: 'yes',
    validation:'dropdown', 
    options: option1,
    mandatory: 1,
  },
  {
    type: 'number', 
    question_no: 'annual_expenditure', 
    question: 'Please provide your approximate Annual Expenditure for financial year under review', 
    description: '(Please enter Rs. in Lac)', 
    depend_question: 'field3',
    condition: 'equals', 
    value: 'yes', 
    validation:'rupee',
    options: [],
    mandatory: 1,
  },
  {
    type: 'texts', 
    question_no: 'specify_entity_name', 
    question: 'Entity Name', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'text',
    options: [],
    mandatory: 1,
    
  },
  {
    type: 'dropdown', 
    question_no: 'year_of_registration', 
    question: 'Year of Registration', 
    description: 'Please write the year in which your organisation was registered as Society/ Trust/ Section 25 or Section 8 Company', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown',
    options: options,
    mandatory: 1,
    disable:true
  },
  {
    type: 'dropdown', 
    question_no: 'have_valid12a', 
    question: 'Does your organisation have a valid 12 A registration under Income Tax act', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown',
    options: [{"option": "Yes"},{"option": "No"}],
    mandatory: 1,
    disable:true
  },
  {
    type: 'dropdown', 
    question_no: 'apply_certification', 
    question: 'Are you applying for certification to meet the requirements of any particular funder/platform/campaign/awards, etc.?', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'dropdown',
    options: [{"option": "Yes"},{"option": "No"}],
    mandatory: 1,
  },
  {
    type: 'text', 
    question_no: 'specify_entity_name', 
    question: 'Certification Entity Name', 
    description: 'If yes, please share the name of the entity. This will help us guide you on the aspects that you should prioritize.', 
    depend_question: 'apply_certification',
    condition: 'equals', 
    value: 'yes', 
    validation:'text',
    options: [],
    mandatory: 0,
  },
  {
    type: 'date', 
    question_no: 'certification_date', 
    question: 'Certification Results Deadline', 
    description: 'If you need the certification results by any particular date, please provide that date. This will help us schedule your application process effectively.', 
    depend_question: '',
    condition: '', 
    value: 'yes', 
    validation:'date',
    options: [],
    mandatory: 0,
  },
  
  {
    type: 'email', 
    question_no: 'email_id', 
    question: 'Email Id', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'email',
    options: [],
    mandatory: 1,
  },

  {
    type: 'text', 
    question_no: 'status', 
    question: 'Expression of Interest Status', 
    description: '', 
    depend_question: '',
    condition: 'equals', 
    value: 'yes', 
    validation:'',
    options: [],
    mandatory: 0,
  },
  
  
];
export const AdditionalCheckBoxDocuments=[
  {
    text:'Entity is a not for profit organisation. Entity is registered as a Trust/Society/Nonprofit Company. Registration does not expire during period of certification.',
    name:'entity_reg',
    type:'checkbox'
  },
  {
    text:'NGO has a Permanent Account Number (PAN) from the Indian Income Tax Department.',
    name:'ngo_pan',
    type:'checkbox'
  },
  {
    text:'Your organisation has physical existence, is operational and can be reached.',
    name:'physical_existence',
    type:'checkbox'
  },
  {
    text:'Existence for a minimum of 1 year from date of registration.  Registration does not expire in the next 6 months of certification.',
    name:'existence_registration',
  },
  {
    text:'Organisation is registered under Sec.12A of Income Tax Act and it remains currently valid.',
    name:'org_current_valid',
  },
  {
    text:'Organisation has filed IT returns for the latest previous financial year ',
    name:'it_returns',
  },
  {
    text:'Organisation has stated aims, objectives, mode of management, rules and regulations in its MOA/ AOA/ Trust Deed/ Constitution (including amendments).',
    name:'org_aims',
  },
  {
    text:'Organisation complies with applicable laws and its own rules.',
    name:'applicable_laws',
  },
  {
    text:'If the organisation is registered under FCRA or if it has obtained prior permission to receive foreign funds then the returns in the prescribed form are filed with FCRA Department, Ministry of Home Affairs, Delhi by the prescribed date irrespective of whether foreign contributions were received or not',
    name:'org_registered_under_fcra',
  },
  {
    text:'I  have been authorized by my organisation to submit this form and complete all necessary processes related to certification.',
    name:'org_auth',
  },
  {
    text:'If our organisation is making the contribution, we hereby declare that the contribution is from our domestic source of funds.',
    name:'org_contribution',
  },
  {
    text:'We understand that if our donor is a foreigner as per FCRA, we will provide donor details as required for the same and collect your FCRA Bank account details for the transfer directly from the donor.',
    name:'donor_foreigner',
  },
  {
    text:'We shall not make any transfer of foreign funds to your organisation under any circumstance.',
    name:'transfer_foreign_funds',
  },
  {
    label: 'Transparency & Accountability',
    name: 'transparency',
  },
  {
    label: 'Donor Requirement',
    name: 'donor_requirement',
  },
  {
    label: 'Credibility',
    name: 'credibility',
  },
  {
    label: 'Fundraising',
    name: 'fundraising_donor',
  },
  {
    label: 'Visibility',
    name: 'visibility',
  },
  {
    label: 'CSR',
    name: 'csr_corporate',
  },
  {
    label: 'Organization Development',
    name: 'organisation_development',
  },
  {
    label: 'Other (Please Specify)',
    name: 'other',
    isCustomInput: true,
    mandatory: 0,
  },
]

export const AdditionalParagraph = [
    {
      undertaking: 'We hereby certify that all the information provided in the GuideStar India Expression of Interest in Certification form as well as the information provided and documents submitted by my organisation on www.guidestarindia.org are true and correct.',
      yes_no: 'No'  // Default to 'No'
    },
    {
        undertaking: 'We understand that only the application form submitted first will be reviewed. We may be certified the key/ badge/ seal of a lower category or may not get any certification, depending on the criteria complied with.',
        yes_no: 'No'
    },
    {
        undertaking: 'We understand that GuideStar India will provide training and capacity building support to undergo the due diligence process for certification. This comprises 3 telephonic/ online interactions, a help PPT and email support.',
        yes_no: 'No'
    },
    {
        undertaking: 'We understand that the GuideStar India Expression of Interest in Certification form is valid for 1 month and we will complete the documentation and required clarification within this period. There will be a maximum of 3 interactions for review of our application and the entire process is to be completed within a month after which our application will be cancelled automatically.',
        yes_no: 'No'
    },
    {
        undertaking: 'We understand that all information provided will be displayed on the GuideStar India website. We understand that GuideStar India will share the list of certified NGOs and information provided, with anyone interested in NGO information. Such information may be provided with or without cost to the person seeking the information.',
        yes_no: 'No'
    },
    {
        undertaking: 'We certify that our organisation has not been blacklisted by any donor/ funding agency/ grant making organisation/ statutory authority.',
        yes_no: 'No'
    },
    {
        undertaking: 'We hereby declare that our organisation is not blacklisted or rejected or subjected to any adverse action by any government department or by any government agency.',
        yes_no: 'No'
    },
    {
        undertaking: 'We hereby certify that our organisation does not employ or deal with any entities or individuals known by our organisation to support terrorism.',
        yes_no: 'No'
    },
    {
        undertaking: 'Our organisation has 12A registration under the Indian Income Tax Act, and it is currently valid.',
        yes_no: 'No'
    },
    {
        undertaking: 'Our organisation complies with all conditions stated in our 12A, 80G (if applicable), 35AC (if applicable) and FCRA (if applicable). We shall inform GuideStar India immediately in the event of any suspension/ cancellation.',
        yes_no: 'No'
    },
    {
        undertaking: "Our organisation works in areas defined as 'charitable in nature' under the Indian Income Tax Act.",
        yes_no: 'No'
    },
    {
        undertaking: "Our governing board ensures that all reporting requirements are met and are in compliance with the Societies Registration Act/ applicable Trust Act/ Indian Companies Act. Organisation has filed returns as specified by Act/Authorities applicable to it for the Financial year 2019-20 and 2018-19/ 2020-21 and 2019-20.",
        yes_no: 'No'
    },
    {
        undertaking: "We hereby declare that our organisation is in compliance with all applicable laws including the Income Tax Act and FCRA.",
        yes_no: 'No'
    },
    {
        undertaking: "We hereby declare that our organisation complies with its own rules & regulations as specified in its Trust Deed/ AOA/ MOA/ Constitution/ Bye Laws.",
        yes_no: 'No'
    },
    {
        undertaking: "Our activities are in line with the Vision, Aim and Objectives of the organisation as stated in our Trust Deed/ MOA/ Constitution.",
        yes_no: 'No'
    },
    {
        undertaking: "Our Governing Body composition is as per our Trust Deed/ AOA/ MOA/ Constitution and as per applicable laws.",
        yes_no: 'No'
    },
    {
        undertaking: "We undertake to provide any clarification within one working day during the certification process.",
        yes_no: 'No'
    },
    {
        undertaking: "We understand that the evaluation for the certification is an objective process. We understand that the decision of GuideStar India in all matters regarding the certification will be final and binding.",
        yes_no: 'No'
    },
    {
        undertaking: "We understand that submission of the online form indicates that we have read these terms and conditions and have accepted them.",
        yes_no: 'No'
    },
    {
        undertaking: 'We hereby certify that all the information provided in the GuideStar India Expression of Interest in Certification form as well as the information provided and documents submitted by my organisation on www.guidestarindia.org are true and correct.',
        yes_no: 'No'
    }
]
